import "./certificados.scss";
import React, { useEffect, useState } from "react";
import TituloCard from "../../atoms/titles/Titulo";
import Button from "../../atoms/buttons/Button";
import {
  aumentarCuadre,
  disminuirCuadre,
  getCuadre,
} from "../../services/IRPFService";
import { SpinnerCircleMini } from "../../atoms/spinner/Spinner";

const CertificadosRet = (object) => {
  const [dispo, setDispo] = useState("");
  const [loading, setLoading] = useState(false);
 
  useEffect(() => {
    getCuadre().then((data) => {
      
      
      setDispo(data);
      setLoading(true);
    });
  }, []);
  return (
    <>
      <TituloCard tipo="tituloModal" titulo={<h2 className="tituloPagina4">Cert. Retenciones</h2>} />
      <TituloCard
        tipo="tituloPagina2 noBg"
        titulo={<h3 className="tituloPagina4">Visualización de certificados de retenciones</h3>}
      />

      {loading ? (
        <div className="fw-bold">{`${dispo}`}
        </div>
      ) : (
        <SpinnerCircleMini></SpinnerCircleMini>
      )}

      <div className="div d-flex">
        <Button
          id="btnAumentar"
          clases="btn-card mt-3"
          nombre={
            <>
              <i className="fa-solid fa-angles-up"> </i>{" "}
              <span className="text-light">Aumentar</span>
            </>
          }
          tipo="button"
          funcion={() => {
            aumentarCuadre().then((data) => {
              setLoading(false);
              
              getCuadre().then((data) => {
                
                setDispo(data);
                setLoading(true);
              });
            });
          }}
        ></Button>
        <Button
          id="btnDisminuir"
          clases="btn-card mt-3"
          nombre={
            <>
              <i className="fa-solid fa-angles-down"> </i>{" "}
              <span className="text-light">Disminuir</span>
            </>
          }
          tipo="button"
          funcion={() => {
            disminuirCuadre().then((data) => {
              setLoading(false);
              
              getCuadre().then((data) => {
                
                setDispo(data);
                setLoading(true);
              });
            });
          }}
        ></Button>
      </div>

    </>
  );
};
export default CertificadosRet;
